import { render, staticRenderFns } from "./CreditCardItem.vue?vue&type=template&id=283d64ee&scoped=true&"
import script from "./CreditCardItem.vue?vue&type=script&lang=js&"
export * from "./CreditCardItem.vue?vue&type=script&lang=js&"
import style0 from "./CreditCardItem.vue?vue&type=style&index=0&id=283d64ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d64ee",
  null
  
)

export default component.exports